export { PaymentContainer } from "./storepayment";
export { ReviewContainer } from "./review";
export { SearchContainer } from "./search";
export { OrderItemContainer } from "./orderitem";
export { OrderSummaryContainer } from "./ordersummary";
export { TrendingProductContainer } from "./trendingproduct";
export { ProductCategoryContainer } from "./categorycontainer";

interface Props {
  children: any;
  bgClass?: string;
}

export const Container: React.FC<Props> = ({ bgClass, children }) => {
  return (
    <div className={`flex flex-col min-h-screen w-full mx-auto relative ${(bgClass?.length || 0) > 0 ? bgClass: "bg-white"}`}>
      {children}
    </div>
  );
};
